import React, { useState, useEffect } from "react";
import {
	IonAlert,
	IonButton,
	IonCol,
	IonContent,
	IonIcon,
	IonImg,
	IonLabel,
	IonModal,
	IonText,
	isPlatform,
} from "@ionic/react";
import "../../global.scss";
import { add, chevronBackOutline, fingerPrint } from "ionicons/icons";
import {
	ADD_NEW_ADDRESS,
	DELETE,
	EDIT,
	MAKE_DEFAULT,
	SELECT_YOUR_VEHICLE,
	ARE_YOU_SURE_YOU_WANT_DELETE_ADDRESS,
	DELETE_ADDRESS,
} from "../../constants";
import PageHeading from "../CustomComponents/PageHeading";
import { connect } from "react-redux";
import {
	COLLECTIONS,
	deleteDataFromFireStore,
	getDoc,
	saveDocumentData,
	setDefaultAddress,
	deleteAddressRef,
	fireStoreDbInstance,
} from "../../firebase";
import {
	setDefAddress,
	updateVehicleDefaultAddress,
	deleteAddress,
	storeUserEditAddressId,
	userVehicles,
	deleteCartItemList,
	saveAddressRef,
	storeCurrentLatLong,
} from "../../Store/Actions";
import { AlertMessage } from "../../utils/alertMessage";
// import { PermissionType, Plugins } from "@capacitor/core";
// const { Permissions } = Plugins;

const MyAdd: React.FC = (props: any) => {
	const [showDeleteAddress, setShowDeleteAddress] = useState(false);
	const [deleteAddressId, setDeleteAddressId] = useState("");
	const [alertMessage, setMessage] = useState({
		showAlert: false,
		message: ARE_YOU_SURE_YOU_WANT_DELETE_ADDRESS,
		deleteCart: false,
	});
	const changeDefaultLocationForVehicle = async (Addressdid: any) => {
		const db = await fireStoreDbInstance();
		const vehicleId = props.location.state.vehicleId;
		const vehicleData = props.userVehiclesList.find((ele: any) => ele.did === vehicleId);
		const payload = {
			...vehicleData,
			defaultAddressRef: `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${Addressdid}`,
		};
		await props.updateVehicleDefaultAddress(payload);
		const { did, ...rest } = payload;
		const id: any = await saveDocumentData(
			props.uid,
			{
				...rest,
				// defaultAddressRef: db.doc(
				//   `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${Addressdid}`
				// ),
				defaultAddressRef: `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${Addressdid}`,
				// documentIds:
				//   Object.keys(rest).includes("documentIds") && rest.documentIds.length
				//     ? rest.documentIds.map((ele: any) => db.doc(ele))
				//     : [],
				documentIds:
					Object.keys(rest).includes("documentIds") && rest.documentIds.length
						? rest.documentIds.map((ele: any) => ele)
						: [],
			},
			COLLECTIONS.USERS,
			COLLECTIONS.VECHICLES,
			vehicleId
		);
		props.history.goBack();
	};

	const deleteAddressData = async () => {
		if (deleteAddressId === props.defaultAddressRef.split("/").pop()) {
			const data: any = await getDoc(props.uid, COLLECTIONS.USERS);
			await deleteAddressRef(props.uid, COLLECTIONS.USERS);
			await props.updateVehicleDefaultAddress({
				...data.data,
				// defaultVehicleRef: !!data.data.defaultVehicleRef
				//   ? data.data.defaultVehicleRef.path
				//   : "",
				defaultVehicleRef: !!data.data.defaultVehicleRef
					? data.data.defaultVehicleRef
					: "",
				defaultAddressRef: "",
			});
		}
		const response = await deleteDataFromFireStore(
			props.uid,
			deleteAddressId,
			COLLECTIONS.USERS,
			COLLECTIONS.ADDRESSES
		);
		await props.userVehicles(
			// console.log("FETCHING USER VEHICLES ......................."),
			props.userVehiclesList.map((ele: any) => {
				if (ele.selectedAddressRef === deleteAddressId) {
					return { ...ele, selectedAddressRef: "" };
				}
				return ele;
			}),
			"dont_merge"
		);
		await props.deleteAddress(deleteAddressId);
		if (response.success) {
			setShowDeleteAddress(false);
		}
		const addressList = props.userAddressList.filter(
			(ele: any) => ele.did !== deleteAddressId
		);
		if (addressList.length) {
			props.saveAddressRef(addressList[0].did);
		}
		//make default address from remaining addresses
		// if (!!props.userAddressList.length) {
		//   const remainingAdd = (props.userAddressList || []).filter(
		//     (add: any) => add.did !== addressId
		//   );
		//   if (!!remainingAdd.length) {
		//     const defDid = remainingAdd[0].did;
		//     setDefaultAddress(
		//       props.uid,
		//       defDid,
		//       COLLECTIONS.USERS,
		//       COLLECTIONS.ADDRESSES
		//     );
		//     props.setDefAddress(
		//       `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${defDid}`
		//     );
		//   }
		// }
	};

	const handleAddressDeletion = (did: string) => {
		if (did === props.selectedAddressRef && props.service_data.length) {
			setMessage({
				showAlert: true,
				message:
					"Are you sure you want to delete the address ? current services added to cart will be lost",
				deleteCart: true,
			});
		} else {
			setMessage({
				showAlert: true,
				message: ARE_YOU_SURE_YOU_WANT_DELETE_ADDRESS,
				deleteCart: false,
			});
		}
	};

	return (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			{isPlatform("ios") && <div className="ios_statusbar_color" />}
			<div className="my_address_header">
				<PageHeading mainHeader="My Addresses" navigation={props} />
			</div>
			<div
				className={
					isPlatform("ios")
						? "addParentDiv-margin upload-document-main-div myAdd_top"
						: "addParentDiv-margin upload-document-main-div"
				}
				style={{ paddingBottom: 50 }}
			>
				{!!(props.userAddressList || []).length ? (
					<div className="address-wrapper">
						{props.userAddressList.map((ele: any, index: any) => (
							<div
								key={index}
								className="address-pill address_details_div"
								onClick={() =>
									!!props.location.state && changeDefaultLocationForVehicle(ele.did)
								}
							>
								<div
									className={
										(props.defaultAddressRef || "").split("/").pop() === ele.did
											? "defadd-container"
											: "defadd-container-empty"
									}
								>
									{(props.defaultAddressRef || "").split("/").pop() === ele.did && (
										<IonLabel className="defadd-text">{"Default"}</IonLabel>
									)}
								</div>

								<IonLabel className="address-type">{ele.addressType}</IonLabel>
								<IonLabel className="address-fulladd">
									{ele.addressline1}
									{", "}
									{ele.landmark}
									{", "}
									{ele.city}
									{", "}
									{ele.postalCode}
									{", "}
									{ele.country}
								</IonLabel>
								<div className="address-action">
									<IonButton
										className="action-text"
										color="darkpink"
										onClick={() => {
											props.storeUserEditAddressId(ele.did);
											const addDetails = props.userAddressList.find(
												(val: any) => val.did === ele.did
											);
											const { latitude, longitude } = addDetails || {};
											props.storeCurrentLatLong(Number(latitude), Number(longitude));
											props.history.push(`/portal/edit-address/${ele.did}`);
										}}
									>
										{EDIT}
									</IonButton>
									<IonButton
										className="action-text"
										color="darkpink"
										onClick={async () => {
											await setDeleteAddressId(ele.did);
											// setShowDeleteAddress(true);
											handleAddressDeletion(ele.did);
										}}
									>
										| {DELETE}
									</IonButton>
									{(props.defaultAddressRef || "").split("/").pop() !== ele.did && (
										<IonButton
											className="action-text"
											color="darkpink"
											onClick={() => {
												setDefaultAddress(
													props.uid,
													ele.did,
													COLLECTIONS.USERS,
													COLLECTIONS.ADDRESSES
												);
												props.setDefAddress(
													`${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${ele.did}`
												);
												props.saveAddressRef(ele.did);
											}}
										>
											{" "}
											| {MAKE_DEFAULT}
										</IonButton>
									)}
								</div>
							</div>
						))}
					</div>
				) : (
					<div style={{ display: "flex", justifyContent: "center" }}>
						<IonLabel>No Saved Addresses</IonLabel>
					</div>
				)}
			</div>
			<div
				className="btn_parent_div add_adresss add-new-address-button"
				onClick={() => {
					props.storeUserEditAddressId("");
					props.history.push("/portal/add-new-address");
				}}
				style={isPlatform("mobileweb") ? { marginBottom: 50 } : {}}
			>
				<IonButton color="customgreen" className="continue_btn child_btn address_add_btn">
					<IonLabel color="light">{ADD_NEW_ADDRESS}</IonLabel>
				</IonButton>
			</div>
			<AlertMessage
				showAlert={alertMessage.showAlert}
				alertMessage={alertMessage.message}
				onDidDismiss={() => {
					setDeleteAddressId("");
					setMessage({
						showAlert: false,
						message: alertMessage.message,
						deleteCart: false,
					});
				}}
				alertHeader={DELETE_ADDRESS}
				actionItemForAlert={async () => {
					deleteAddressData();
					if (alertMessage.deleteCart) {
						await props.deleteCartItemList();
					}
					setMessage({
						showAlert: false,
						message: alertMessage.message,
						deleteCart: false,
					});
				}}
				cssClass="alert-message"
			/>
			{/* <AlertMessage
        showAlert={showDeleteAddress}
        alertMessage={ARE_YOU_SURE_YOU_WANT_DELETE_ADDRESS}
        onDidDismiss={() => {
          setShowDeleteAddress(false);
        }}
        alertHeader={DELETE_ADDRESS}
        actionItemForAlert={async () => {
          deleteAddressData();
        }}
        cssClass="alert-message"
      /> */}
		</IonCol>
	);
};

export default connect(
	({
		auth,
		userInfo: { userAddressList, userVehiclesList, selectedAddressRef },
		cart: { service_data },
	}: any) => {
		return {
			...auth,
			userAddressList,
			userVehiclesList,
			selectedAddressRef,
			service_data,
		};
	},
	{
		setDefAddress,
		updateVehicleDefaultAddress,
		deleteAddress,
		storeUserEditAddressId,
		userVehicles,
		deleteCartItemList,
		saveAddressRef,
		storeCurrentLatLong,
	}
)(MyAdd);

export const knowLocationPermission = async (props: any) => {
	// const ans = await Permissions.query({ name: PermissionType.Geolocation });
	// props.saveLocationPermissionStatus(ans.state);
	return ""; // ans.state;
};
